import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { printInventoryToFill } from '../Api'

export default generateApiAction({
  baseType: Types.PRINT.INVENTORY_TO_FILL,
  api: printInventoryToFill,
  responseType: RESPONSETYPE.FILE
})



// WEBPACK FOOTER //
// ./src/actions/print/PrintInventoryToFillAction.js